module.exports = __webpack_public_path__ + "static/hunday-8fa0d309c98f185812b9459e25690915.png";